module.exports = __webpack_public_path__ + "img/meetings.e423daf4.svg";